// helper function to check is arguments is not null or undefined but can be 0
export function isValue(...args) {
  return args.every((arg) => arg !== null && arg !== undefined);
}
